module.exports = __webpack_public_path__ + "img/gaotao_p.e84d6440.png";